import React, { useState, useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import './styles.scss'
import Heading from '../heading/Heading';
import Input from '../form/inputs/Input';
import InputPostal from '../form/inputs/InputPostal';
import Button from '../buttons/Button';
import { createMuiTheme } from "@material-ui/core";
import Select from '../form/selects/Select';
import "moment/locale/pl";
import Moment from 'moment';
import banks from './../../static-data/banks.json';
import scrollPage from '../../services/scrollToErrors';
import Checkbox from '../form/checkbox/Checkbox';

const materialTheme = createMuiTheme({
    overrides: {
        MuiPickersCalendarHeader: {
            switchHeader: {
                color: '#74726b',
            },
          },
      MuiPickersDay: {
            day: {
                color: '#74726b',
            },
        },
    }
  });

const CustomerInformation = ( props ) => {
    let [ load, setLoad ]                           = useState(false);
    let [ isOpen, setIsOpen ]                       = useState(false);
    let [ forceValidateNip, setForceValidateNip ]   = useState(false);
    let [ forceValidate, setForceValidate ]         = useState(false);
    let [ companyStartPicker, setCompanyStartPicker ] = useState(false);
    let [ dataFromGUS, setDataFromGUS ] = useState(false);

    const dispatch      = useDispatch()
    let nip             = useSelector(state => state.nip)
    let companyName     = useSelector(state => state.companyName)
    let companyAddress  = useSelector(state => state.companyAddress)
    let postalCustomer  = useSelector(state => state.postalCustomer)
    let city            = useSelector(state => state.city)
    let additionalCompanyAddress  = useSelector(state => state.additionalCompanyAddress)
    let additionalPostalCustomer  = useSelector(state => state.additionalPostalCustomer)
    let additionalCity            = useSelector(state => state.additionalCity)
    let phone           = useSelector(state => state.phone)
    let email           = useSelector(state => state.email)
    let emailFV         = useSelector(state => state.emailFV)
    let employeesNumber = useSelector(state => state.employeesNumber)
    let website         = useSelector(state => state.website)
    let additionalAddress       = useSelector(state => state.additionalAddress)
    let bank       = useSelector(state => state.bank)
    let bankAccountsNumbers     = useSelector(state => state.bankAccountsNumbers)
    let bankAccount             = useSelector(state => state.bankAccount)
    let otherBankAccountCheckbox = useSelector(state => state.otherBankAccountCheckbox)
    let otherBankAccount        = useSelector(state => state.otherBankAccount)
    let consentAutomaticBankAccountCheckbox = useSelector(state => state.consentAutomaticBankAccountCheckbox);

    
    
    let validateNIP = async () => {
        await setForceValidateNip(true);
        await wait(100);

        let result;
        let elements = document.querySelectorAll('.error-item-nip');
        if( elements.length > 0 ) {
            result = false;
            await setForceValidateNip(false);
        } else {
            result = true;
        }
        return result;
    }

    let getDataFromGUS = async (type) => {
        let validateNip = await validateNIP();
        await wait(100);
        if ( validateNip ) {
            let req = new XMLHttpRequest();
            req.open('GET', `https://newonline.leasingoptymalny.pl/API/nip2.php?id=5c3fe4b4fce445d481e92a660953&nip=${nip}`);
            req.send();

            req.addEventListener("readystatechange", function () {
                if (this.readyState === 4) {
                    let data = JSON.parse(req.response);
                    if(data && data.dane && data.dane.ErrorCode !== "4") {
                        if(!type) {
                            dispatch({ type: 'COMPANY_NAME_CHANGE', value: data.dane.Nazwa })
                            dispatch({ type: 'COMPANY_ADDRESS_CHANGE', value: data.dane.Ulica + ' ' + data.dane.NrNieruchomosci })
                            dispatch({ type: 'COMPANY_START_CHANGE', value: data.dane.dataRozpoczeciaDzialalnosci })

                            dispatch({ type: 'POSTAL_CUSTOMER_CHANGE', value: data.dane.KodPocztowy })
                            dispatch({ type: 'CITY_CHANGE', value: data.dane.Miejscowosc })
                            dispatch({ type: 'GUS_DATA_CHANGE', value: data.dane })
                            dispatch({ type: 'REGISTRY_TYPE_CHANGE', value: data.dane.Krs && data.dane.Krs.length > 0  ? 'KRS' : 'CEIDG' })
                            dispatch({ type: 'ID_NUMBER_CHANGE', value: data.dane.Krs && data.dane.Krs.length > 0 ? data.dane.Krs : '' })
                            dispatch({ type: 'PROFESSION_CHANGE', value: data.dane.pkdKod  })
                        }else if(type == "register_type") {
                            dispatch({ type: 'GUS_DATA_CHANGE', value: data.dane })
                            dispatch({ type: 'REGISTRY_TYPE_CHANGE', value: data.dane.Krs && data.dane.Krs.length > 0  ? 'KRS' : 'CEIDG' })
                            dispatch({ type: 'ID_NUMBER_CHANGE', value: data.dane.Krs && data.dane.Krs.length > 0 ? data.dane.Krs : '' })
                            dispatch({ type: 'COMPANY_START_CHANGE', value: data.dane.dataRozpoczeciaDzialalnosci })
                            dispatch({ type: 'PROFESSION_CHANGE', value: data.dane.pkdKod  })
                        }
                        getAccountNumbers();
                        setDataFromGUS(true);
                    }
                }
            });
        }
    }

    let getAccountNumbers = () => {
        let date = Moment(new Date()).format("YYYY-MM-DD")
        let req = new XMLHttpRequest();
            req.open('GET', `https://wl-api.mf.gov.pl/api/search/nip/${nip}?date=${date}`);
            req.setRequestHeader("accept", "application/json"); 
            req.send();

            req.addEventListener("readystatechange", function () {
                if (this.readyState === 4) {
                    let data = JSON.parse(req.response);
                    if(data && data.result && data.result.subject && data.result.subject.accountNumbers) {
                        let accountsNumbersArr = [];
                        for(let i = 0; i<data.result.subject.accountNumbers.length; i++) {
                            let item = data.result.subject.accountNumbers[i];
                            accountsNumbersArr = [...accountsNumbersArr, {
                                name: item,
                                val: item,
                                key: i
                            }]
                        }
                        dispatch({ type: 'BANK_ACCOUNTS_NUMBERS_CHANGE', value: accountsNumbersArr })
                    }else{
                        dispatch({ type: 'BANK_ACCOUNTS_NUMBERS_CHANGE', value: [] })
                        dispatch({ type: 'OTHER_BANK_ACCOUNT_CHECKBOX_CHANGE', value: true })
                    }
                }
            });
    }


    const getBankUrlRedirect = ( key ) => {
        if ( key.length == 0 ) {
            return false;
        }
        let getItem = banks.findIndex(x => x.name === key);

        let req = new XMLHttpRequest();
            req.open('GET', `https://newonline.leasingoptymalny.pl/API/linkVeryf.php?id=5c3fe4b4fce445d481e92a660953&bank=${ banks[getItem].key }`);
            req.send();

            req.addEventListener("readystatechange", function () {
                if (this.readyState === 4) {
                    let data = JSON.parse(req.response);
                    if(data && data.redirect_uri) {
                        dispatch({ type: 'BANK_URI_CHANGE', value: data.redirect_uri })
                    }
                }
            });
        
    }
    async function wait(ms) {
        return new Promise(resolve => {
          setTimeout(resolve, ms);
        });
    }
    
    let prev = () => {
        props.prev();
    }
    let next = async() => {
        await setForceValidate(true);
        await wait(500);
        let scroll = await scrollPage();
        if ( scroll ) {
            await setForceValidate(true);
        } else {
            await setForceValidate(false);
            await props.next();
        }
    }

    let changeAdditionalAddress = ( val ) => {
        dispatch({ type: 'ADDITIONAL_ADDRESS_CHANGE', value: val })

        if ( !val ) {
            dispatch({ type: 'ADDITIONAL_COMPANY_ADDRESS_CHANGE', value: '' })
            dispatch({ type: 'ADDITIONAL_POSTAL_CUSTOMER_CHANGE', value: '' })
            dispatch({ type: 'ADDITIONAL_CITY_CHANGE', value: '' })
        }
    }

    const getDataAndNext = async() => {
        if(nip && !dataFromGUS) {
            await getDataFromGUS("register_type");
            await wait(500);
        }
        await next();
    }

    return (
        <div className="customer-information">
                <Heading title="Dane adresowe" medium />
                <div className="input-row">
                    <div className="col">
                        <Input  name="nip"
                            id="nip"
                            required={ true }
                            setFunction={ val => { dispatch({ type: 'NIP_CHANGE', value: val }) } }
                            type="text"
                            placehold={ "NIP" }
                            val={ nip }
                            size="xxl" 
                            errorClass="error-item-nip"
                            regExp={/^[0-9]{10}$/}
                            allowChars={/^[0-9]{0,10}$/}
                            minChar={ 1 } 
                            forceValidate={ forceValidateNip || forceValidate ? true : false } 
                            forceValidateItems={ forceValidate }
                            tip={ true } 
                            tipHeader="NIP"
                            tipText="Wpisz 10-cyfrowy numer NIP i pobierz automatycznie dane firmy, korzystając z przycisku obok. Możesz również samodzielnie uzupełnić kolejne pola."/>
                    </div>
                </div>

                <div className="input-row">
                    <div className="col">
                        <Button title="Pobierz dane firmy" class="white" download={ true } setFunction={ () => getDataFromGUS() } />
                    </div>
                </div>

                <div className="input-row">
                    <div className="col">
                        <Input  name="full-name-company"
                            id="full-name-company"
                            required={ true }
                            setFunction={ val => dispatch({ type: 'COMPANY_NAME_CHANGE', value: val }) }
                            type="text"
                            placehold={ "Pełna nazwa firmy" }
                            val={ companyName }
                            size="xxl" 
                            regExp={/.*/}
                            allowChars={/.*/}
                            minChar={ 1 } 
                            forceValidate={ forceValidate } />
                    </div>
                    
                </div>

                <div className="input-row">
                    <div className="col">
                        <Input  name="address-company"
                                id="address-company"
                                required={ true }
                                setFunction={ val => dispatch({ type: 'COMPANY_ADDRESS_CHANGE', value: val }) }
                                type="text"
                                placehold={ "Adres siedziby" }
                                val={ companyAddress }
                                size="xxl" 
                                regExp={/.*/}
                                allowChars={/.*/}
                                minChar={ 1 } 
                                forceValidate={ forceValidate } />
                    </div>
                    <div className="col">
                        <InputPostal 
                            id="provider-postal"
                            name={"provider-postal"}
                            required={ true }
                            setFunction={ val => dispatch({ type: 'POSTAL_CUSTOMER_CHANGE', value: val }) }
                            type="text"
                            placehold={ "Kod pocztowy" }
                            val={ postalCustomer } 
                            size="xxl" 
                            regExp="\d{2}-\d{3}$" 
                            allowChars={/^[0-9]{0,5}$/} 
                            minChar={ 6 } 
                            forceValidate={ forceValidate } />
                    </div>
                    <div className="col">
                        <Input  name="city"
                                id="city"
                                required={ true }
                                setFunction={ val => dispatch({ type: 'CITY_CHANGE', value: val }) }
                                type="text"
                                placehold={ "Miejscowość" }
                                val={ city }
                                size="xxl" 
                                regExp={/.*/}
                                allowChars={/.*/}
                                minChar={ 1 } 
                                forceValidate={ forceValidate } />
                    </div>
                </div>

                <div className="input-row">
                    <div className="col">
                        <Checkbox   required={ false } 
                                    id="additionalAddress"
                                    setFunction={ (val) => changeAdditionalAddress(val) }
                                    val={ additionalAddress }
                                    forceValidate={ forceValidate }
                                    text="Dodaj adres do korespondencji (wskaż, gdy adres jest inny niż powyżej)" />
                    </div>
                </div>
                { additionalAddress &&
                    <div className="input-row">
                        <div className="col">
                            <Input  name="additional-address-company"
                                    id="additional-address-company"
                                    required={ true }
                                    setFunction={ val => dispatch({ type: 'ADDITIONAL_COMPANY_ADDRESS_CHANGE', value: val }) }
                                    type="text"
                                    // placehold={ "Adres siedziby" }
                                    placehold={ "Ulica i numer" }
                                    val={ additionalCompanyAddress }
                                    size="xxl" 
                                    regExp={/.*/}
                                    allowChars={/.*/}
                                    minChar={ 1 } 
                                    forceValidate={ forceValidate } />
                        </div>
                        <div className="col">
                            <InputPostal 
                                id="additional-provider-postal"
                                name={"additional-provider-postal"}
                                required={ true }
                                setFunction={ val => dispatch({ type: 'ADDITIONAL_POSTAL_CUSTOMER_CHANGE', value: val }) }
                                type="text"
                                placehold={ "Kod pocztowy" }
                                val={ additionalPostalCustomer } 
                                size="xxl" 
                                regExp="\d{2}-\d{3}$" 
                                allowChars={/^[0-9]{0,5}$/} 
                                minChar={ 6 } 
                                forceValidate={ forceValidate } />
                        </div>
                        <div className="col">
                            <Input  name="additional-city"
                                    id="additional-city"
                                    required={ true }
                                    setFunction={ val => dispatch({ type: 'ADDITIONAL_CITY_CHANGE', value: val }) }
                                    type="text"
                                    placehold={ "Miejscowość" }
                                    val={ additionalCity }
                                    size="xxl" 
                                    regExp={/.*/}
                                    allowChars={/.*/}
                                    minChar={ 1 } 
                                    forceValidate={ forceValidate } />
                        </div>
                    </div>
                }
                
                <Heading title="Informacje o firmie" medium />

                {/* <div className="input-row"> */}
                    {/* <div className="col">
                        <InputCalendar  name="start-company"
                            id="start-company"
                            required={ true }
                            setFunction={ val => dispatch({ type: 'COMPANY_START_CHANGE', value: val }) }
                            openCalendar={ () => setIsOpen( true) }
                            type="text"
                            placehold={ "Data założenia firmy" }
                            val={ companyStart }
                            size="xxl" 
                            calendar={ true }
                            regExp={/([12]\d{3}-(0[1-9]|1[0-2])-(0[1-9]|[12]\d|3[01]))/}
                            allowChars={/^[0-9-]{0,10}$/}
                            minChar={ 1 } 
                            maxDate={new Date()}
                            forceValidate={ forceValidate } />
                        <ThemeProvider theme={materialTheme}>
                            <MuiPickersUtilsProvider utils={MomentUtils} locale="pl">
                                <KeyboardDatePicker
                                    cancelLabel="Anuluj"
                                    value={ companyStartPicker }
                                    placeholder="2018-10-10"
                                    onChange={date => { dispatch({ type: 'COMPANY_START_CHANGE', value: moment(date).format("YYYY-MM-DD") }); setCompanyStartPicker(date) }}
                                    maxDate={new Date()}
                                    format="YYYY-MM-DD"
                                    open={isOpen}
                                    onOpen={() => setIsOpen(true)}
                                    onClose={() => setIsOpen(false)}
                                />
                            </MuiPickersUtilsProvider>
                        </ThemeProvider>
                    </div>
                    <div className="col">
                        <Select
                            id="type-register"
                            required={ true }
                            data={ registryTypes }  
                            forceValidate={ forceValidate } 
                            val={registryType}
                            placehold="Rodzaj rejestru" 
                            setFunction={ (val) => dispatch({ type: 'REGISTRY_TYPE_CHANGE', value: val })}
                            tip={ true } 
                            tipHeader="Rodzaj rejestru"
                            tipText="Wybierz CEIDG dla osób fizycznych prowadzących działalność gospodarczą oraz spółek cywilnych. Wybierz KRS dla pozostałych form działalności." />
                    </div>
                    <div className="col">
                        <Input  name="id-number"
                                id="id-number"
                                required={ (registryType == "KRS" ? true : false ) }
                                setFunction={ val => dispatch({ type: 'ID_NUMBER_CHANGE', value: val }) }
                                type="text"
                                placehold={ "Numer KRS" }
                                val={ idNumber }
                                size="xxl" 
                                regExp={/^[0-9]{0,10}$/}
                                allowChars={/^[0-9]{0,10}$/}
                                minChar={ (registryType == "KRS" ? 1 : 0 ) } 
                                forceValidate={ forceValidate } 
                                disabledForce={ (registryType == "CEIDG" ? true : false )} />
                    </div> */}
                {/* </div> */}

                <div className="line" />

                {/* <div className="input-row"> */}
                    {/* <div className="col">

                        { legalForm && 
                            <Select
                                id="legal-form"
                                data={ lawForms }  
                                required={ true }
                                forceValidate={ forceValidate } 
                                val={ lawForm }
                                placehold="Forma prawna" 
                                setFunction={ (val) => dispatch({ type: 'LAW_FORM_CHANGE', value: val }) } />
                        }
                    </div>
                    <div className="col">   
                        <Select
                            id="profession"
                            data={ professions }  
                            forceValidate={ forceValidate } 
                            val={ profession }    
                            required={ true }
                            placehold="Rodzaj działalności / profesja" 
                            setFunction={ (val) => dispatch({ type: 'PROFESSION_CHANGE', value: val }) } 
                            columns={ true }
                            toLeft={ true } />
                    </div> */}
                    
                {/* </div> */}

                <div className="line" />

                <div className="input-row">
                    <div className="col">
                        <Input  name="phone"
                                id="phone"
                                required={ true }
                                setFunction={ val => dispatch({ type: 'PHONE_CHANGE', value: val }) }
                                type="text"
                                placehold={ "Telefon komórkowy" }
                                val={ phone }
                                size="xxl" 
                                regExp={/^[+0-9]{9,13}$/}
                                allowChars={/^[+0-9]{0,13}$/}
                                minChar={ 1 } 
                                forceValidate={ forceValidate } />
                    </div>
                    
                    <div className="col">
                        <Input  name="website"
                                id="website"
                                required={ false }
                                setFunction={ val => dispatch({ type: 'WEBSITE_CHANGE', value: val }) }
                                type="text"
                                placehold={ "Strona www" }
                                val={ website }
                                size="xxl" 
                                regExp={/.*/}
                                allowChars={/.*/}
                                minChar={ 0 } 
                                forceValidate={ forceValidate } />
                    </div>
                    <div className="col">
                        <Input  name="employees-number"
                                id="employees-number"
                                required={ true }
                                setFunction={ val => dispatch({ type: 'EMPLOYEES_NUMBER_CHANGE', value: val }) }
                                type="text"
                                placehold={ "Liczba pracowników" }
                                val={ employeesNumber }
                                size="xxl" 
                                regExp={/^[0-9]*$/}
                                allowChars={/^[0-9]*$/}
                                minChar={ 1 } 
                                forceValidate={ forceValidate } 
                                tip={ true } 
                                tipHeader="Liczba pracowników"
                                tipText="Wpisz łączną liczbę pracowników, niezależnie od formy zatrudnienia. W przypadku działalności jednoosobowej bez osób zatrudnionych, wpisz 0."/>
                    </div>
                </div>  
                
                <div className="input-row">
                    <div className="col">
                        <Input  name="email"
                                id="email"
                                required={ true }
                                setFunction={ val => dispatch({ type: 'EMAIL_CHANGE', value: val }) }
                                type="text"
                                placehold={ "Adres e-mail do kontaktu" }
                                val={ email }
                                size="xxl" 
                                regExp={/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,6})+$/}
                                allowChars={/.*/}
                                minChar={ 1 } 
                                forceValidate={ forceValidate } />
                    </div>
                    <div className="col">
                        <Input  name="emailFV"
                                id="emailFV"
                                required={ false }
                                setFunction={ val => dispatch({ type: 'EMAIL_FV_CHANGE', value: val }) }
                                type="text"
                                placehold={ "Adres e-mail do e-faktur" }
                                val={ emailFV }
                                size="xxl" 
                                regExp={/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,6})+$/}
                                allowChars={/.*/}
                                minChar={ 1 } 
                                forceValidate={ forceValidate } 
                                tip={ true } 
                                tipHeader="E-FAKTURY"
                                tipText={ 'Adres e-mail w przypadku faktur dostarczanych drogą elektroniczną. Wypełnienie pola oznacza zgodę na otrzymywanie faktur drogą elektroniczną na zasadach wskazanych w Regulaminie e-faktur, patrz <a href="https://media.grenke.com/download/downloadgateway.dll/getfile?p_inst_id=32279944&amp;p_session_id=&amp;p_obt_id=3477865&amp;p_spec_id=1" target="_blank">TUTAJ.</a>' } />
                    </div>
                    <div className="col">
                        <Select
                            id="bank"
                            data={ banks }  
                            required={ true }
                            forceValidate={ forceValidate } 
                            val={ bank }
                            placehold="Nazwa banku firmowego" 
                            setFunction={ (val) => { dispatch({ type: 'BANK_CHANGE', value: val }); getBankUrlRedirect(val) } } />
                    </div>
                </div>
                {/* account nr start */}
                
                <div className="input-row">
                    {/* {bankAccountsNumbers && bankAccountsNumbers.length > 0 && bankAccountsNumbers !== "empty" && */}
                        <div className="col">
                            <Select
                                id="bank_accounts"
                                data={ bankAccountsNumbers }  
                                selectIfOne={ true }
                                required={ true }
                                forceValidate={ forceValidate } 
                                val={ bankAccount }
                                disabledForce={ (bankAccountsNumbers.length == 0 || otherBankAccountCheckbox ) ? true : false }
                                placehold="Nr konta do regulowania rat" 
                                setFunction={ (val) => dispatch({ type: 'BANK_ACCOUNT_CHANGE', value: val }) } />
                        </div>
                    {/* } */}
                    {/* {(bankAccountsNumbers && bankAccountsNumbers.length > 0 || bankAccountsNumbers == "empty") && */}
                        <>
                            <div className="col">
                                <Checkbox   required={ false } 
                                            id="other_bank_checkbox"
                                            setFunction={ (val) => dispatch({ type: 'OTHER_BANK_ACCOUNT_CHECKBOX_CHANGE', value: val }) }
                                            val={ otherBankAccountCheckbox }
                                            forceValidate={ forceValidate }
                                            class="xxl" 
                                            text="Dodaj inny nr konta (wskaż, gdy nr konta inny niż na liście)" />
                            </div>
                            {otherBankAccountCheckbox &&
                            <div className="col">
                                <Input  name="other_bank_account"
                                        id="other_bank_account"
                                        required={ true }
                                        disabledForce={ otherBankAccountCheckbox ? false : true }
                                        setFunction={ val => dispatch({ type: 'OTHER_BANK_ACCOUNT_CHANGE', value: val }) }
                                        type="text"
                                        placehold={ "Wskaż numer konta" }
                                        val={ otherBankAccount }
                                        size="xxl" 
                                        regExp={/^[0-9]*$/}
                                        allowChars={/^[0-9]*$/}
                                        minChar={ 26 } 
                                        maxChar={ 26 }
                                        forceValidate={ forceValidate } />
                            </div>
                            }
                            {!otherBankAccountCheckbox &&
                                <div className="col">
                                    <Checkbox   required={ false } 
                                                id="consent_automatic_bank_account"
                                                setFunction={ (val) => dispatch({ type: 'CONSENT_AUTOMATIC_BANK_ACCOUNT_CHECKBOX_CHANGE', value: val }) }
                                                val={ consentAutomaticBankAccountCheckbox }
                                                forceValidate={ forceValidate }
                                                class="xxl" 
                                                text="Zgoda na automatyczne obciążenie rachunku" />
                                </div>
                            }
                        </>
                    {/* } */}
                </div>
                {otherBankAccountCheckbox &&
                    <div className="input-row">
                        <>
                            <div className="col">
                                <Checkbox   required={ false } 
                                            id="consent_automatic_bank_account"
                                            setFunction={ (val) => dispatch({ type: 'CONSENT_AUTOMATIC_BANK_ACCOUNT_CHECKBOX_CHANGE', value: val }) }
                                            val={ consentAutomaticBankAccountCheckbox }
                                            forceValidate={ forceValidate }
                                            class="xxl" 
                                            text="Zgoda na automatyczne obciążenie rachunku" />
                            </div>
                        </>
                    </div>
                }

                {/* account nr end */}
                <div className="line" />

                <div className="input-row nav-buttons">
                    <div className="col">
                        <Button title="Powrót" class="white reverse" arrowPrevBlue={ true } setFunction={ () => prev() } />
                    </div>
                    <div className="col"></div>
                    <div className="col">
                        {/* <Button title="Dalej" class="blue" arrow={ true } setFunction={ () => next() } /> */}
                        <Button title="Dalej" class="blue" arrow={ true } setFunction={ () => getDataAndNext() } />
                    </div>
                </div>
        </div>
    )
}

export default CustomerInformation;